import { http } from '@/http'

export default {
  downloadTemplate() {
    return http.get('/contracts/bulk-edit/template', { responseType: 'blob' })
  },
  validate(file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.post('/contracts/bulk-edit/validate', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  confirm(batchId) {
    return http.post(`/contracts/bulk-edit/confirm/${batchId}`)
  },
  downloadErrors(batchId) {
    return http.get(`/contracts/bulk-edit/errors/${batchId}`, { responseType: 'blob' })
  },
}
